import { Box, makeStyles } from "@material-ui/core";
import React from "react";
import { Helmet } from "react-helmet";
import Particles from "react-tsparticles";
import ZennyaLogo from "zennya.svg";

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    top: 0,
    left: 0,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },

    height: "100%",
  },
  logoContainer: {
    height: 92,
    width: "100%",
    marginTop: "100px",
    position: "relative",
    marginLeft: "0px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "-10px",
    },
  },
}))

const ParticleLanding = () => {
  const classes = useStyles()

  return (
    <div className="particleLand">
      <Helmet>
          <title>Zennya Health</title>
      </Helmet>
      <Particles
        options={{
          background: {
            image: "url('/assets/images/zennya-white.svg')",
            position: "50% 50%",
            repeat: "no-repeat",
            size: "300px",
          },
          fullScreen: {
            enable: true,
            zIndex: 1,
          },
          fpsLimit: 60,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "grab",
                parallax: {
                  enable: true,
                  force: 100,
                  smooth: 20,
                },
              },
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.4,
                size: 8,
              },
              grab: {
                distance: 400,
                links: {
                  consent: true,
                  opacity: 0.25,
                },
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: {
                value: "#ffffff",
              },
              distance: 150,
              enable: true,
              opacity: 0.2,
            },
            move: {
              attract: {
                rotate: {
                  x: 600,
                  y: 1200,
                },
              },
              enable: true,
              path: {},
              outModes: {
                bottom: "out",
                left: "out",
                right: "out",
                top: "out",
              },
            },
            number: {
              density: {
                enable: true,
                area: 10000,
              },
            },
            opacity: {
              value: {
                min: 0.1,
                max: 0.5,
              },
              animation: {
                speed: 3,
                minimumValue: 0.1,
              },
            },
            reduceDuplicates: true,
            size: {
              value: {
                min: 2,
                max: 5,
              },
              animation: {
                speed: 20,
                minimumValue: 0.1,
              },
            },
          },
        }}
      />
    </div>
  );
};

export { ParticleLanding };
